import React from 'react';

import DashboardLayout from './../layouts/dashboard';

import Grid from '@material-ui/core/Grid';

import { Reports } from './../../components/Reports';

export const ReportsPage = () => {
  return (
    <DashboardLayout title={'Reportes'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <Reports />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
